

//create CRUD class with axios
import axios, { AxiosResponse } from 'axios';
import DataService from './dataservice.base';


export default class InventoryTransactionDataService extends DataService {


    constructor(path :string) {
        super(path);
        
    }

    async getBalance() { 
        return await this.axios.get(`${this.apiUrl}${this.path}/balance?storeId=${this.storeId}`);
    }
    // GET /inventories-tx/{startDate}/{endDate} — รายการเคลื่อนไหวสต็อกตามช่วงวันทำการ
    // ใช้ที่หน้า /inventory/history
    async fetchBetweenDates(startDate: string, endDate: string) {
        return await this.axios.get(`${this.apiUrl}${this.path}/${startDate}/${endDate}?storeId=${this.storeId}`);
    }

    // GET /inventories-tx/logs/{stockId}/{date} — ประวัติรายบรรทัดของสต็อก 1 ตัวในวันเดียว
    // ใช้กับ modal ที่หน้า /inventory/detail
    async fetchStockLogsByDate(stockId: string, date: string) {
        return await this.axios.get(`${this.apiUrl}${this.path}/logs/${encodeURIComponent(stockId)}/${date}?storeId=${this.storeId}`);
    }

    async reportSummaryRange(payload) { 
        if (!payload.storeId) {
            payload.storeId  = this.storeId;
        }
        return await this.axios.post(`${this.apiUrl}${this.path}/report/summary-range?storeId=${this.storeId}`, payload);
    }

    async reportStockItemByDate(payload) {

        if (!payload.storeId) {
            payload.storeId  = this.storeId; 
        }

        return await this.axios.post(`${this.apiUrl}${this.path}/report/stock-item-by-date`, payload)
        // return await this.axios.post(`${this.apiUrl}${this.path}/report/stock-item-by-date?storeId=${this.storeId}`, payload);
    }

    async posSold(payload) {

        if (!payload.storeId) {
            payload.storeId  = this.storeId; 
        }

        return await this.axios.post(`${this.apiUrl}${this.path}/pos-sold`, payload)
        // return await this.axios.post(`${this.apiUrl}${this.path}/report/stock-item-by-date?storeId=${this.storeId}`, payload);
    }

    // ---------------------------------------------------------------
    // /inventories-v2/* — หน้าสต๊อกแบบคำนวณในเครื่อง (local mode)
    // route ใหม่ทั้งหมด ไม่แตะ /inventories-tx/* ที่ frontend เดิมใช้
    // ส่ง storeId ชัด ๆ ทุกครั้ง ไม่ใช้ storeId ที่จำไว้ในตัว service
    // (แคชผูกกับร้าน ถ้าร้านเปลี่ยนกลางทางต้องไม่ดึงข้อมูลร้านอื่นมาปน)
    // ---------------------------------------------------------------

    // POST /inventories-v2/sync — ไม่ส่ง checkpoint = ขอเลขล่าสุด, ส่ง = ขอแถวที่เปลี่ยนหลังเลขนั้น
    async syncStock(storeId: string, checkpoint?: number) {
        const body: any = { storeId };
        if (checkpoint !== undefined) body.checkpoint = checkpoint;
        return await this.axios.post(`${this.apiUrl}/inventories-v2/sync`, body);
    }

    // GET /inventories-v2/all — แถว ledger ทั้งร้านทีละหน้า (~3MB) สำหรับ full load
    async fetchStockAllPage(storeId: string, cursor: string | null) {
        let url = `${this.apiUrl}/inventories-v2/all?storeId=${encodeURIComponent(storeId)}`;
        if (cursor) url += `&cursor=${encodeURIComponent(cursor)}`;
        return await this.axios.get(url);
    }

    // fire-and-forget : สั่งตามเก็บสต็อกย้อนหลัง ได้ response กลับทันที ไม่รอคำนวณ
    // ใช้ตอนเปิดร้าน POS จะได้ขายต่อได้เลย
    async recoverPosSold(payload) {

        if (!payload.storeId) {
            payload.storeId  = this.storeId;
        }

        return await this.axios.post(`${this.apiUrl}${this.path}/recover-pos-sold`, payload)
    }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { InventoryTransactionDataService };
